import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';

import { defineCustomElements } from '@uoa/web-components/loader';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { UoaErrorsConfig, ErrorToastService, provideErrorPages } from '@uoa/error-pages';
import { AppErrorsConfig } from './app/core/services/app-errors-config.service';
import { AppToastService } from './app/core/services/app-toast.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { LoadingIndicatorModule, NumericSummaryModule } from './app/shared';
import { NumericGpaPageModule } from './app/pages/numeric-gpa/numeric-gpa.module';
import { NonNumericPageModule } from './app/pages/non-numeric/non-numeric.module';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}


bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
          BrowserModule, 
          IonicModule.forRoot({ mode: 'md' }), 
          AppRoutingModule, 
          IonicStorageModule.forRoot(), 
          LoadingIndicatorModule, 
          NumericGpaPageModule, 
          NonNumericPageModule, 
          NumericSummaryModule, 
          FormsModule
        ),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: UoaErrorsConfig, useClass: AppErrorsConfig },
        { provide: ErrorToastService, useClass: AppToastService },
        provideErrorPages(),
        provideHttpClient(withInterceptorsFromDi())
    ]
}).catch((err) => console.log(err));

defineCustomElements();
